(function () {
  var SECTION_SELECTOR = '.oddit-header';
  var section = document.querySelector(SECTION_SELECTOR);
  if (!section) return;

  var megaMenu = section.querySelector('[data-mega-menu]');
  var megaTriggers = section.querySelectorAll('[data-mega-menu-trigger]');
  var megaCloseTimer = null;
  var activeTrigger = null;

  var mobileMenu = section.querySelector('[data-mobile-menu]');
  var mobileToggleBtn = section.querySelector('[data-mobile-menu-toggle]');
  var mobileCloseBtns = section.querySelectorAll('[data-mobile-menu-close]');

  function isHoverPointer(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  function openMegaMenu(label) {
    if (!megaMenu) return;
    var panels = megaMenu.querySelectorAll('[data-mega-menu-label]');
    for (var p = 0; p < panels.length; p++) {
      var panel = panels[p];
      if (!panel.hasAttribute('data-mega-menu-trigger')) {
        panel.style.display = panel.getAttribute('data-mega-menu-label') === label ? '' : 'none';
      }
    }
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
  }

  function closeMegaMenu() {
    if (!megaMenu) return;
    megaMenu.classList.remove('is-open');
    megaMenu.setAttribute('aria-hidden', 'true');
    for (var t = 0; t < megaTriggers.length; t++) {
      megaTriggers[t].setAttribute('aria-expanded', 'false');
    }
    activeTrigger = null;
  }

  function openMegaMenuFor(trigger) {
    clearTimeout(megaCloseTimer);
    var label = trigger.getAttribute('data-mega-menu-label');
    for (var t = 0; t < megaTriggers.length; t++) {
      megaTriggers[t].setAttribute('aria-expanded', 'false');
    }
    trigger.setAttribute('aria-expanded', 'true');
    activeTrigger = trigger;
    openMegaMenu(label);
  }

  function scheduleCloseMegaMenu() {
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(function () {
      closeMegaMenu();
    }, 180);
  }

  for (var t = 0; t < megaTriggers.length; t++) {
    (function (trigger) {
      var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (trigger.getAttribute('aria-expanded') === 'true') {
          closeMegaMenu();
        } else {
          openMegaMenuFor(trigger);
        }
      });

      if (wrapper) {
        wrapper.addEventListener('pointerenter', function (e) {
          if (!isHoverPointer(e)) return;
          openMegaMenuFor(trigger);
        });
        wrapper.addEventListener('pointerleave', function (e) {
          if (!isHoverPointer(e)) return;
          scheduleCloseMegaMenu();
        });
      }
    })(megaTriggers[t]);
  }

  if (megaMenu) {
    megaMenu.addEventListener('pointerenter', function (e) {
      if (!isHoverPointer(e)) return;
      clearTimeout(megaCloseTimer);
    });
    megaMenu.addEventListener('pointerleave', function (e) {
      if (!isHoverPointer(e)) return;
      scheduleCloseMegaMenu();
    });
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileToggleBtn) mobileToggleBtn.setAttribute('aria-expanded', 'true');
    mobileMenu.style.height = (window.innerHeight - section.getBoundingClientRect().bottom) + 'px';
    document.body.style.overflow = 'hidden';
    var firstFocusable = mobileMenu.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileToggleBtn) mobileToggleBtn.setAttribute('aria-expanded', 'false');
    mobileMenu.style.height = '';
    document.body.style.overflow = '';
    if (mobileToggleBtn) mobileToggleBtn.focus();
  }

  if (mobileToggleBtn) {
    mobileToggleBtn.addEventListener('click', function () {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  for (var c = 0; c < mobileCloseBtns.length; c++) {
    mobileCloseBtns[c].addEventListener('click', closeMobileMenu);
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobileMenu();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && megaMenu && megaMenu.classList.contains('is-open')) {
      closeMegaMenu();
      if (activeTrigger) activeTrigger.focus();
    }
  });

  var stuckFrame = null;

  function syncStuckState() {
    stuckFrame = null;
    section.classList.toggle('is-stuck', section.getBoundingClientRect().top <= 0);
  }

  function requestStuckSync() {
    if (stuckFrame !== null) return;
    stuckFrame = window.requestAnimationFrame(syncStuckState);
  }

  window.addEventListener('scroll', requestStuckSync, { passive: true });
  window.addEventListener('resize', requestStuckSync, { passive: true });
  syncStuckState();

  var cartToggles = section.querySelectorAll('[data-cart-toggle]');
  for (var ct = 0; ct < cartToggles.length; ct++) {
    cartToggles[ct].addEventListener('click', function () {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    var counts = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = cart.item_count;
    }
  });
})();